import coreModule from 'app/core/core_module';

export class ExperimentSrv {
  cache = {};
  rootObjectCount = -1;
  rootObjectRequests = [];

  /* @ngInject */
  constructor(private $q, private backendSrv, private $routeParams) {}

  getCurrentId() {
    return this.$routeParams.experimentId;
  }

  getCurrent() {
    let experimentId = this.getCurrentId();

    if (!experimentId) {
      return new Promise((resolve, reject) => {
        reject('Experiment id missing.');
      });
    }

    return this.get(experimentId);
  }

  get(experimentId) {
    return new Promise((resolve, reject) => {
      if (this.cache[experimentId]) {
        resolve(this.cache[experimentId]);
      } else {
        return this.backendSrv.getExperiment(experimentId).then(
          exp => {
            this.cache[experimentId] = exp;
            resolve(exp);
          },
          err => {
            reject(err);
          }
        );
      }
    });
  }

  setRootObjectCount(count) {
    this.rootObjectCount = count;
    for (let deferred of this.rootObjectRequests) {
      deferred.resolve(count);
    }
    this.rootObjectRequests = [];
  }

  getRootObjectCount() {
    if (this.rootObjectCount !== -1) {
      return this.$q.resolve(this.rootObjectCount);
    }

    let deferred = this.$q.defer();
    this.rootObjectRequests.push(deferred);
    return deferred.promise;
  }

  clearCache() {
    this.cache = {};
  }
}

coreModule.service('experimentSrv', ExperimentSrv);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/services/experiment_srv.ts